window.mobileBusinessSearcher = () => {
  const $categorySearcherDesktop = $('#category-name');
  const $categorySearcherMobile = $('#interactive-category-name');
  const $locationSearcherMobile = $('#interactive-location-name');
  const $mobileModal = $('#mobile-modal');
  let modalInstance;
  let stepsManager;

  const getSteps = () => {
    return $('[data-step]')
      .map(function () {
        return $(this).attr('data-step');
      })
      .get();
  };

  const postParentEscapedEvent = () => {
    window.parent.postMessage("businessSearcherModalEscaped", "*");
  };

  const postParentOpenedEvent = () => {
    window.parent.postMessage("businessSearcherModalOpened", "*");
  };

  const restoreMobileContent = () => {
    $('#business-mobile-searcher').appendTo($mobileModal)
  };

  const clearMobileInputsSearchers = () => {
    $categorySearcherMobile
      .categorySearcher('val', '')
      .val('');

    $locationSearcherMobile
      .typeahead('val', '')
  };

  const displayModal = $element => {
    const $modalContent = $('<div id="bootbox-mobile-content"></div>');
    modalInstance = bootbox.dialog({
      message: $mobileModal.children().appendTo($modalContent),
      className: 'mobile-business-search-modal',
      onEscape: function () {
        postParentEscapedEvent();
        restoreMobileContent();
        clearMobileInputsSearchers();

        $mobileModal.trigger('businessSearcherModalClosed');
      },
    });

    modalInstance.init(function () {
      const stepType = $element.data('step-type');

      if (!stepsManager) {
        const steps = getSteps();
        // Come from web components
        stepsManager = Utilities.createStepManager(steps);
      }

      clearMobileInputsSearchers();
      postParentOpenedEvent();
      stepsManager.hideActiveStep();
      if (!$categorySearcherDesktop.val()) {
        stepsManager.showFirstStep();
      } else {
        stepsManager.showStep(stepType, true);
      }
    });
  };

  const successUserSelection = () => {
    if (stepsManager && !stepsManager.isCurrLatestStep()) {
      stepsManager.goToNextStep();
    }

    $mobileModal.trigger("mobileSearcher_DoSearch");
  };

  $('[data-interaction="search-modal"]').on('click', function (ev) {
    if (isMobile()) {
      displayModal($(this));
      ev.stopPropagation();

      window.onpopstate = function (e) {
        if (!e.state) {
          postParentEscapedEvent();
          restoreMobileContent();
          clearMobileInputsSearchers();

          $mobileModal.trigger('businessSearcherModalClosed');
          modalInstance.modal('hide');
        } else {
          stepsManager.goToStep(e.state.step);
        }
      };

      if (!stepsManager) {
        return;
      }

      if (window.history.state) {
        window.history.replaceState({
          step: stepsManager.getCurrentStepName()
        }, '', '');
      } else {
        window.history.pushState({
          step: stepsManager.getCurrentStepName()
        }, '', '');
      }
    }
  });

  $categorySearcherMobile.on('typeahead:selected typeahead:autocompleted', function (evt, category) {
    $(this).blur();
    $('[name="category-name"]').val($('[name="interactive-category-name"]').val());
    stepsManager.goToNextStep();

    window.history.pushState({
      step: 'location-step'
    }, '', '');
  });

  $locationSearcherMobile.on('typeahead:selected typeahead:autocompleted', function (evt, location) {
    setTimeout(successUserSelection, 0);

    window.history.pushState({
      step: 'category-step'
    }, '', '');
  });

  $locationSearcherMobile.on('change', function (evt, location) {
    successUserSelection();
  });

  $('#loading-step').append(window.ContentPlaceholder.getPlaceholder('geometric-placeholder'));
};
